import type { CurrentActor } from "../api/session-api";

/** The calendar projection contains all five scoped record families. */
export function canReadScheduleCalendar(actor: Pick<CurrentActor, "permissions"> | null): boolean {
  return (
    [
      "partner-schedules.read",
      "partner-offerings.read",
      "experiences.read",
      "destinations.read",
      "partners.read",
    ] as const
  ).every((permission) => actor?.permissions.includes(permission) === true);
}
